// extracted by mini-css-extract-plugin
export default {"brandPromo":"EJ-z","carousel":"FJ-z"};